import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
const NextStudioLayoutComponent = ({ children }) => /* @__PURE__ */ jsx(
  "div",
  {
    id: "sanity",
    "data-ui": "NextStudioLayout",
    style: {
      height: "100vh",
      maxHeight: "100dvh",
      overscrollBehavior: "none",
      WebkitFontSmoothing: "antialiased",
      overflow: "auto"
    },
    children
  }
), NextStudioLayout = memo(NextStudioLayoutComponent), NextStudioNoScript = () => /* @__PURE__ */ jsx("noscript", { children: /* @__PURE__ */ jsx(
  "div",
  {
    style: {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      background: "#fff",
      zIndex: 1
    },
    children: /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          fontFamily: "helvetica, arial, sans-serif"
        },
        children: [
          /* @__PURE__ */ jsx("h1", { children: "JavaScript disabled" }),
          /* @__PURE__ */ jsxs("p", { children: [
            "Please ",
            /* @__PURE__ */ jsx("a", { href: "https://www.enable-javascript.com/", children: "enable JavaScript" }),
            " in your browser and reload the page to proceed."
          ] })
        ]
      }
    )
  }
) });
export {
  NextStudioLayout,
  NextStudioNoScript
};
//# sourceMappingURL=NextStudioNoScript.js.map
